import { AppThunk } from '../../../store/rootReducer';
import * as AnnotationTaskClient from '../clients/annotation-task.client';
import * as adminActions from '../actions/admin.actions';

export const loadTasks =
  (
    status: string,
    currentPage: number,
    startDate: string,
    endDate: string,
    searchInput: string,
    selectedAnnotators: string[],
    selectedGrids: string[],
    selectedEfforts: string[],
  ): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(adminActions.setIsLoading({ isLoading: true }));
      const loadTasks = await AnnotationTaskClient.loadAnnotationTasks(
        status,
        currentPage,
        startDate,
        endDate,
        searchInput,
        selectedAnnotators,
        selectedGrids,
        selectedEfforts,
      );
      if (loadTasks) {
        if (status === 'ongoing')
          dispatch(
            adminActions.loadActive({
              activeAnnotationTasks: loadTasks,
              currentPage: currentPage,
            }),
          );
        else
          dispatch(
            adminActions.loadInactive({
              inactiveAnnotationTasks: loadTasks,
              currentPage: currentPage,
            }),
          );
      }
    } catch (error) {
      console.error('Error to load active annotation tasks:', error);
    } finally {
      dispatch(adminActions.setIsLoading({ isLoading: false }));
    }
  };
